import _defineProperty from "/build/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";
import _objectWithoutProperties from "/build/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/objectWithoutProperties.js";
const _excluded = ["onSubmit"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import React from "react";
import { useForm } from "react-hook-form";
import { useState, useCallback } from "react";
import { SearchInputField } from "./Parts/index";
import classnames from "classnames";
var IconSearch = function IconSearch(props) {
  return /*#__PURE__*/_jsxs("svg", _objectSpread(_objectSpread({}, props), {}, {
    children: [/*#__PURE__*/_jsx("circle", {
      clipRule: "evenodd",
      fill: "none",
      stroke: "#AAA",
      strokeWidth: "1.32",
      strokeMiterlimit: "10",
      cx: "7.75",
      cy: "7.75",
      r: "7"
    }), /*#__PURE__*/_jsx("path", {
      clipRule: "evenodd",
      fill: "none",
      stroke: "#AAA",
      strokeWidth: "1.32",
      strokeMiterlimit: "10",
      d: "M19.463 19.463 12.7 12.7"
    })]
  }));
};
IconSearch.defaultProps = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 20 20",
  xmlSpace: "preserve"
};
import styles from "@/styles/Form.module.scss";
import { useDeviceInfoQuery } from "@/hooks";
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export default function ChannelSearchFormSp(_ref) {
  let {
      onSubmit
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  const {
    0: focus,
    1: setFocus
  } = useState(false);
  const {
    register,
    handleSubmit
  } = useForm();
  const {
    data
  } = useDeviceInfoQuery({
    fetchPolicy: "cache-first"
  });
  const deviceInfo = data === null || data === void 0 ? void 0 : data.deviceInfo;
  const handleKeyDown = useCallback(e => {
    // Return
    if (e.key === "Enter" && deviceInfo !== null && deviceInfo !== void 0 && deviceInfo.isMobile) {
      setTimeout(() => {
        e.target.blur();
      }, 200);
    }
  }, [deviceInfo]);
  const handleFocus = useCallback(() => {
    setFocus(true);
  }, []);
  const handleBlur = useCallback(() => {
    setFocus(false);
  }, []);
  return /*#__PURE__*/_jsxs("form", {
    action: "#",
    onSubmit: handleSubmit(onSubmit),
    className: styles.channelSearchFormSp,
    noValidate: true,
    children: [/*#__PURE__*/_jsx("button", {
      type: "button",
      className: styles.showChannelSearchFormBtn,
      children: /*#__PURE__*/_jsx(IconSearch, {})
    }), /*#__PURE__*/_jsx("div", {
      className: classnames(styles.channelSearchFormSpInner, {
        [styles.focused]: focus
      }),
      children: /*#__PURE__*/_jsx(SearchInputField, _objectSpread({
        ref: register,
        name: "search",
        placeholder: "\u5546\u54C1\u5185\u691C\u7D22",
        onKeyDown: handleKeyDown,
        onFocus: handleFocus,
        onBlur: handleBlur
      }, props))
    })]
  });
}